import React from "react"
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material"
import { useFormikContext } from "formik"
import i18n from "@/i18n"
import {
  getMinReservationTimeOptions,
  getMaxReservationTimeOptions,
  getReservationBufferOptions,
  getCancellationDeadlineOptions,
} from "@/constants/reservation_rules"
import { SETTINGS_SECTION_STYLES } from "@/components/settings/_styles"

const STYLES = {
  ...SETTINGS_SECTION_STYLES,
} as const

const ReservationTiming: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const minOptions = getMinReservationTimeOptions()
  const maxOptions = getMaxReservationTimeOptions()
  const bufferOptions = getReservationBufferOptions()
  const cancellationDeadlineOptions = getCancellationDeadlineOptions()

  return (
    <div className={STYLES.container} data-testid="settings-venue-rules-timing-container">
      <h2 className={STYLES.header}>{i18n.t("app.settings.venues.reservation_rules.timing.title")}</h2>
      <div className={STYLES.grid}>
        <FormControl fullWidth>
          <InputLabel id="min-res-label">
            {i18n.t("app.settings.venues.reservation_rules.fields.min_reservation_time")}
          </InputLabel>
          <Select
            labelId="min-res-label"
            label={i18n.t("app.settings.venues.reservation_rules.fields.min_reservation_time")}
            value={values.minReservationTime}
            onChange={(e) => setFieldValue("minReservationTime", e.target.value)}
            data-testid="settings-venue-rules-timing-select-min-time"
          >
            {minOptions.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="max-res-label">
            {i18n.t("app.settings.venues.reservation_rules.fields.max_reservation_time")}
          </InputLabel>
          <Select
            labelId="max-res-label"
            label={i18n.t("app.settings.venues.reservation_rules.fields.max_reservation_time")}
            value={values.maxReservationTime}
            onChange={(e) => setFieldValue("maxReservationTime", e.target.value)}
            data-testid="settings-venue-rules-timing-select-max-time"
          >
            {maxOptions.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <p className={STYLES.helperText}>{i18n.t("app.settings.venues.reservation_rules.helpers.reservation_timing")}</p>

      <FormControl fullWidth className="mt-4">
        <InputLabel id="buffer-label">
          {i18n.t("app.settings.venues.reservation_rules.fields.reservation_buffer")}
        </InputLabel>
        <Select
          labelId="buffer-label"
          label={i18n.t("app.settings.venues.reservation_rules.fields.reservation_buffer")}
          value={values.reservationBuffer}
          onChange={(e) => setFieldValue("reservationBuffer", e.target.value)}
          data-testid="settings-venue-rules-timing-select-buffer"
        >
          {bufferOptions.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText className="text-gray-500">
          {i18n.t("app.settings.venues.reservation_rules.helpers.reservation_buffer")}
        </FormHelperText>
      </FormControl>

      <h3 className={STYLES.subheader}>{i18n.t("app.settings.venues.reservation_rules.cancellation.title")}</h3>
      <FormControl fullWidth>
        <InputLabel id="cancellation-deadline-label">
          {i18n.t("app.settings.venues.reservation_rules.fields.cancellation_deadline")}
        </InputLabel>
        <Select
          labelId="cancellation-deadline-label"
          label={i18n.t("app.settings.venues.reservation_rules.fields.cancellation_deadline")}
          value={values.cancellationDeadline}
          onChange={(e) => setFieldValue("cancellationDeadline", e.target.value)}
          data-testid="settings-venue-rules-timing-select-cancellation"
        >
          {cancellationDeadlineOptions.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText className="text-gray-500">
          {i18n.t("app.settings.venues.reservation_rules.helpers.cancellation_deadline")}
        </FormHelperText>
      </FormControl>
    </div>
  )
}

export default ReservationTiming
